<div class="container-fluid py-4">
  <div class="row justify-content-center">
    <!-- Profile Card -->
    <div class="col-lg-6 col-md-8 col-sm-12">
      <div class="card p-3 shadow-sm">
        <div class="d-flex align-items-center">
          <!-- Profile Image -->
          <img [src]="profileData.profileImage" 
               alt="Profile" 
               class="rounded-circle profile-img cursor-pointer"
               width="150" height="150"
               data-bs-toggle="modal" data-bs-target="#imageModal"
               (click)="openImageModal(profileData.profileImage)">
          
          <div class="ms-3">
            <!-- Profile Name and Nickname -->
            <h5 class="mb-1 fs-4">{{ profileData.name }} 
              <span class="text-muted">({{ profileData.nickname }})</span>
            </h5>
            <p class="text-primary fw-bold">{{ profileData.profileType }}</p>

            <!-- Basic Details (Mobile, Address, Location) in a responsive layout -->
            <div class="basic-details mt-2">
              <div class="d-flex flex-column flex-sm-row justify-content-between">
                <p class=""><strong>📞 Mobile</strong><br> {{ profileData.mobileNumber }}</p>
                <p class="ms-5"><strong>🏠 Address</strong><br> {{ profileData.address }}</p>
                <p class="ms-5"><strong>📍 Location</strong><br> {{ profileData.location }}</p>
              </div>
            </div>
          </div>
        </div>
        
        <!-- Tab Buttons -->
        <div class="d-flex">
          <button class="btn btn-outline-primary flex-fill me-2" (click)="setActiveTab('posts')">Posts</button>
          <button class="btn btn-outline-primary flex-fill me-2" (click)="setActiveTab('issues')">Issues</button>
          <button class="btn btn-outline-primary flex-fill" (click)="setActiveTab('myservices')">My Services</button>
        </div>
      </div>
    </div>
  </div>

  <!-- Content Section -->
  <div class="row justify-content-center mt-3">
    <div class="col-lg-6 col-md-8 col-sm-12">
      <div class="p-3 border rounded shadow-sm bg-white">
        <div *ngIf="activeTab === 'posts'">
          <h5>📢 All Posts</h5>
          <div *ngFor="let post of posts" class="border-bottom py-2">
            <h6>{{ post.title }}</h6>
            <p>{{ post.content }}</p>
            <div *ngIf="post.media">
              <img *ngIf="post.media.type === 'image'" [src]="post.media.url" class="img-fluid rounded">
              <video *ngIf="post.media.type === 'video'" class="w-100" controls>
                <source [src]="post.media.url" type="video/mp4">
              </video>
            </div>
          </div>
        </div>

        <div *ngIf="activeTab === 'issues'">
          <h5>🐞 Issues</h5>
          <div *ngFor="let issue of issues" class="border-bottom py-2">
            <h6>{{ issue.title }}</h6>
            <p>{{ issue.description }}</p>
          </div>
        </div>

        <div *ngIf="activeTab === 'myservices'">
          <h5>🛠️ My Services</h5>
          <div *ngFor="let service of services" class="border-bottom py-2">
            <h6>{{ service.name }}</h6>
            <p>{{ service.description }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Modal for Full Image View -->
  <div class="modal fade" id="imageModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ profileData.name }}'s Profile Picture</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
        </div>
        <div class="modal-body text-center">
          <img [src]="selectedImage" class="img-fluid rounded">
        </div>
      </div>
    </div>
  </div>
</div>
